import { isValidElement } from 'react';
import classNames from 'classnames';

const pushDivider = (actions) => {
  const lastAction = actions[actions.length - 1];
  if (actions.length > 0 && lastAction?.type !== 'divider') {
    actions.push({ show: true, type: 'divider' });
  }
};

export const dedupeConsecutiveDividers = (actions) =>
  actions.filter((action, index) => {
    if (action.type !== 'divider') {
      return true;
    }

    return index === 0 || actions[index - 1]?.type !== 'divider';
  });

const createDivider = (action) => ({
  show: true,
  type: 'divider',
  ...(action.stayAfterLogicGroup ? { stayAfterLogicGroup: true } : {}),
});

export const insertActionDividers = (actions) => {
  const result = [];

  actions.forEach((action) => {
    if (action.type === 'divider') {
      result.push(action);
      return;
    }

    const lastAction = result[result.length - 1];

    if (action.dividerBefore && lastAction?.type !== 'divider') {
      result.push(createDivider(action));
    }

    result.push(action);

    if (action.dividerAfter) {
      result.push(createDivider(action));
    }
  });

  return dedupeConsecutiveDividers(result);
};

const trimEdgeDividers = (actions) => {
  let start = 0;
  let end = actions.length;

  while (start < end && actions[start]?.type === 'divider') {
    start += 1;
  }

  while (end > start && actions[end - 1]?.type === 'divider') {
    end -= 1;
  }

  return actions.slice(start, end);
};

export const groupLogicActionsInMenu = (actions) => {
  const logicActions = [];
  const beforeLogic = [];
  const afterLogic = [];
  let seenLogic = false;

  actions.forEach((action) => {
    if (action.isLogicAction) {
      seenLogic = true;
      logicActions.push(action);
      return;
    }

    if (action.stayAfterLogicGroup) {
      afterLogic.push(action);
      return;
    }

    if (!seenLogic) {
      beforeLogic.push(action);
      return;
    }

    beforeLogic.push(action);
  });

  if (logicActions.length === 0) {
    return trimEdgeDividers(dedupeConsecutiveDividers(actions));
  }

  const result = [...beforeLogic];

  if (result.length > 0) {
    pushDivider(result);
  }

  result.push(...logicActions);

  if (afterLogic.length > 0) {
    pushDivider(result);
    result.push(...afterLogic);
  }

  return dedupeConsecutiveDividers(result);
};

export const getDropdownMenuActionDetails = (action, item) => {
  const {
    icon = null,
    className = null,
    text = null,
    disabled = false,
  } = action;

  let actionIcon = null;
  let actionClassName = null;
  let actionText = null;
  let actionDisabled = null;

  if (isValidElement(icon)) {
    actionIcon = icon;
  } else if (typeof icon === 'function') {
    actionIcon = icon(item);
  }
  if (typeof className === 'string') {
    actionClassName = className;
  } else if (typeof className === 'function') {
    actionClassName = className(item);
  }
  if (isValidElement(text)) {
    actionText = text;
  } else if (typeof text === 'function') {
    actionText = text(item);
  } else if (typeof text === 'string') {
    actionText = text;
  }
  if (typeof disabled === 'boolean') {
    actionDisabled = disabled;
  } else if (typeof disabled === 'function') {
    actionDisabled = disabled(item);
  }
  return {
    icon: actionIcon,
    className: classNames('full-size-link', actionClassName),
    text: actionText,
    disabled: actionDisabled,
  };
};
